export default "__VITE_ASSET__02f67605__"